import { ApiAccountPersisted, ApiAccount } from "@rmp/api-gateway";
import { Account } from "@rmp/core/types/account/account";

export class ApiAccountMapper {
	static map(source: Account): ApiAccount {
		return {
			...source
		};
	}
	
	static getEmpty(): ApiAccount {
		return {
			login: "",
			email: "",
			isActive: false,
			isEmailConfirmed: false
		};
	}
}

export class ApiAccountPersistedMapper {
	static getEmpty(): ApiAccountPersisted {
		return {
			id: "",
			createdAt: "",
			updatedAt: "",
			account: ApiAccountMapper.getEmpty()
		};
	}
}
